// Your custom JS here
import './header';
import { initSlider } from './slider';
import { initAnimations } from './animations';
import './woo';


// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    // Initialize slider functionality
    initSlider();
    
    // Initialize animations
    initAnimations();

    const archiveProducts = document.querySelector('archive-products');
    const itemsPerPage = archiveProducts ? parseInt(archiveProducts.getAttribute('data-items-per-page'), 10) || 6 : 6;
    const loadMoreBtn = document.getElementById('load-more-products');
    const productList = document.getElementById('custom-products-list');
    const filterForm = document.getElementById('product-filter-form');
    let currentPage = 1;
    let lastPageReached = false;

    // Preloaded next page data from PHP
    let preloadedNextPageHtml = (typeof next_page_data !== 'undefined') ? next_page_data.html : '';
    let preloadedHasMore = (typeof next_page_data !== 'undefined') ? (next_page_data.hasMore === true || next_page_data.hasMore === 'true') : false;
    let preloadedPage = (typeof next_page_data !== 'undefined') ? next_page_data.currentPage : 2;

    // Skeleton loader HTML
    function getSkeletonHTML(count = itemsPerPage) {
        let skeleton = '';
        for (let i = 0; i < count; i++) {
            skeleton += `
                <li class="skeleton-card animate-pulse bg-gray-200 rounded-xl h-[340px] flex flex-col items-center justify-center">
                    <div class="w-[90%] h-[180px] bg-gray-300 rounded-lg mb-4"></div>
                    <div class="w-2/3 h-6 bg-gray-300 rounded mb-2"></div>
                    <div class="w-1/3 h-4 bg-gray-300 rounded mb-2"></div>
                    <div class="w-1/2 h-8 bg-gray-300 rounded"></div>
                </li>
            `;
        }
        return skeleton;
    }

    // Helper to get all filter params as FormData
    function getFilterFormData(page = 1) {
        const formData = new FormData(filterForm);
        formData.append('action', 'filter_products');
        formData.append('paged', page);
        formData.append('limit', itemsPerPage);
        return formData;
    }

    // Preload next page via AJAX
    function preloadNextPage(page) {
        const formData = getFilterFormData(page);
        fetch(woocommerce_params.ajax_url, {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            preloadedNextPageHtml = data.html;
            preloadedHasMore = data.has_more || data.hasMore;
            preloadedPage = page;
        });
    }

    // Instant filter: submit form on any filter change
    if (filterForm) {
        filterForm.querySelectorAll('.js-instant-filter').forEach(input => {
            input.addEventListener('change', function() {
                filterForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
            });
        });
    }

    // Filter form submission
    if (filterForm) {
        filterForm.addEventListener('submit', function(e) {
            e.preventDefault();
            currentPage = 1;
            lastPageReached = false;
            // Reset preloaded data on filter change
            preloadedNextPageHtml = '';
            preloadedHasMore = false;
            preloadedPage = 2;
            productList.innerHTML = getSkeletonHTML(itemsPerPage);
            const formData = getFilterFormData(currentPage);
            fetch(woocommerce_params.ajax_url, {
                method: 'POST',
                body: formData
            })
            .then(response => response.json())
            .then(data => {
                productList.innerHTML = data.html;
                if (data.html.includes('No products found') || data.html.trim() === '' || !data.has_more) {
                    if (loadMoreBtn) loadMoreBtn.style.display = 'none';
                    lastPageReached = true;
                } else {
                    if (loadMoreBtn) loadMoreBtn.style.display = 'block';
                    // Preload next page after filter
                    preloadNextPage(currentPage + 1);
                }
            })
            .catch((err) => {
                productList.innerHTML = `
                <div class="max-w-[340px] mx-auto text-center"><div class="flex justify-center mb-[30px]">${get_icon('image-cart-empty')}</div><h2 class="text-[30px] lg:text-[42px] leading-[1.1] font-wulkan-display font-semibold text-primary-950/50 mb-[30px]">Error loading products</h2><div class="button-area"><a href="${woocommerce_params.shop_url}" class="btn btn-primary min-w-[240px]">Return to shop</a></div></div>
                `;
                if (loadMoreBtn) loadMoreBtn.style.display = 'none';
            });
        });
    }

    // Load more products
    if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', function(e) {
            e.preventDefault();
            if (lastPageReached) return;
            // Use preloaded data if available and for the correct page
            if (preloadedNextPageHtml && preloadedPage === currentPage + 1 && preloadedNextPageHtml.trim() !== '' && !preloadedNextPageHtml.includes('No products found')) {
                productList.insertAdjacentHTML('beforeend', preloadedNextPageHtml);
                currentPage = preloadedPage;
                if (preloadedHasMore) {
                    if (loadMoreBtn) loadMoreBtn.style.display = 'block';
                    preloadNextPage(currentPage + 1);
                } else {
                    if (loadMoreBtn) loadMoreBtn.style.display = 'none';
                    lastPageReached = true;
                }
                preloadedNextPageHtml = '';
            } else {
                // fallback: fetch as before if not preloaded
                currentPage++;
                const formData = getFilterFormData(currentPage);
                if (loadMoreBtn) {
                    loadMoreBtn.textContent = 'Loading...';
                    loadMoreBtn.disabled = true;
                }
                fetch(woocommerce_params.ajax_url, {
                    method: 'POST',
                    body: formData
                })
                .then(response => response.json())
                .then(data => {
                    if (data.html && !data.html.includes('No products found') && data.html.trim() !== '') {
                        productList.insertAdjacentHTML('beforeend', data.html);
                        if (loadMoreBtn) loadMoreBtn.style.display = (data.has_more || data.hasMore) ? 'block' : 'none';
                        if (data.has_more || data.hasMore) {
                            preloadNextPage(currentPage + 1);
                        } else {
                            lastPageReached = true;
                        }
                    } else {
                        lastPageReached = true;
                        if (loadMoreBtn) loadMoreBtn.style.display = 'none';
                    }
                })
                .catch((err) => {
                    if (loadMoreBtn) loadMoreBtn.style.display = 'none';
                })
                .finally(() => {
                    if (loadMoreBtn) {
                        loadMoreBtn.textContent = 'Load More';
                        loadMoreBtn.disabled = false;
                    }
                });
            }
        });
    }

    // Filter and Sort panel open/close logic
    const filterBtn = document.getElementById('filter-toggle-btn');
    const filterPanel = document.getElementById('filter-panel');
    
    const sortBtn = document.getElementById('sort-toggle-btn');
    const sortPanel = document.getElementById('sort-panel');

    // Filter dropdown logic
    if (filterBtn && filterPanel) {
        filterBtn.addEventListener('click', () => {
            // Close sort panel if open
            if (sortPanel && sortPanel.classList.contains('opacity-100')) {
                sortPanel.classList.add('opacity-0', 'pointer-events-none', 'scale-95');
                sortPanel.classList.remove('opacity-100', 'pointer-events-auto', 'scale-100');
            }
            // Toggle filter panel
            filterPanel.classList.toggle('opacity-0', filterPanel.classList.contains('opacity-100'));
            filterPanel.classList.toggle('pointer-events-none', filterPanel.classList.contains('opacity-100'));
            filterPanel.classList.toggle('scale-95', filterPanel.classList.contains('opacity-100'));
            filterPanel.classList.toggle('opacity-100', !filterPanel.classList.contains('opacity-100'));
            filterPanel.classList.toggle('pointer-events-auto', !filterPanel.classList.contains('opacity-100'));
            filterPanel.classList.toggle('scale-100', !filterPanel.classList.contains('opacity-100'));
        });
    }

    // Sort dropdown logic
    if (sortBtn && sortPanel) {
        sortBtn.addEventListener('click', () => {
            // Close filter panel if open
            if (filterPanel && filterPanel.classList.contains('opacity-100')) {
                filterPanel.classList.add('opacity-0', 'pointer-events-none', 'scale-95');
                filterPanel.classList.remove('opacity-100', 'pointer-events-auto', 'scale-100');
            }
            // Toggle sort panel
            sortPanel.classList.toggle('opacity-0', sortPanel.classList.contains('opacity-100'));
            sortPanel.classList.toggle('pointer-events-none', sortPanel.classList.contains('opacity-100'));
            sortPanel.classList.toggle('scale-95', sortPanel.classList.contains('opacity-100'));
            sortPanel.classList.toggle('opacity-100', !sortPanel.classList.contains('opacity-100'));
            sortPanel.classList.toggle('pointer-events-auto', !sortPanel.classList.contains('opacity-100'));
            sortPanel.classList.toggle('scale-100', !sortPanel.classList.contains('opacity-100'));
        });
    }

    // Close dropdowns on outside click
    document.addEventListener('mousedown', (e) => {
        // Close filter panel
        if (
            filterPanel && filterPanel.classList.contains('opacity-100') &&
            !filterPanel.contains(e.target) &&
            !filterBtn.contains(e.target)
        ) {
            filterPanel.classList.add('opacity-0', 'pointer-events-none', 'scale-95');
            filterPanel.classList.remove('opacity-100', 'pointer-events-auto', 'scale-100');
        }
        
        // Close sort panel
        if (
            sortPanel && sortPanel.classList.contains('opacity-100') &&
            !sortPanel.contains(e.target) &&
            !sortBtn.contains(e.target)
        ) {
            sortPanel.classList.add('opacity-0', 'pointer-events-none', 'scale-95');
            sortPanel.classList.remove('opacity-100', 'pointer-events-auto', 'scale-100');
        }
    });
});


document.addEventListener('DOMContentLoaded', function() {
    // Add to cart button icon state management
    function setButtonIconState($button, state) {
        const $defaultIcon = $button.find('.btn-icon-default');
        
        // Remove existing state icons
        $button.find('.btn-icon-loading, .btn-icon-success').remove();
        
        // Show the appropriate icon
        switch(state) {
            case 'loading':
                $defaultIcon.hide();
                $button.append(`
                    <svg class="btn-icon-loading animate-spin w-5 h-5 text-white" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                `);
                break;
            case 'success':
                $defaultIcon.hide();
                $button.append(`
                    <svg class="btn-icon-success w-5 h-5 text-white" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" fill="none"/>
                        <path d="M8 12l3 3 5-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                `);
                break;
            case 'default':
            default:
                $button.find('.btn-icon-loading, .btn-icon-success').remove();
                $defaultIcon.show();
                break;
        }
    }
    
    // Flying cart animation
    function flyToCart($productCard) {
        // Target the cart-pickup container which is always visible
        const $miniCart = jQuery('#cart-pickup-container');
        
        if (!$miniCart.length || !$productCard.length) {
            console.log('Cart container not found for animation');
            return;
        }
        
        // Get positions first
        const cardOffset = $productCard.offset();
        const cartOffset = $miniCart.offset();
        
        // Clone the entire product card for animation
        const $clone = $productCard.clone()
            .css({
                position: 'fixed',
                zIndex: 9999,
                pointerEvents: 'none'
            })
            .appendTo('body');
        
        // Set initial position and size
        $clone.css({
            top: cardOffset.top + 'px',
            left: cardOffset.left + 'px',
            width: $productCard.outerWidth() + 'px',
            height: $productCard.outerHeight() + 'px'
        });
        
        // Calculate transform origin relative to the clone's position
        const cloneOffset = $clone.offset();
        const originX = cartOffset.left - cloneOffset.left;
        const originY = cartOffset.top - cloneOffset.top;
        
        // Set transform origin to cart position
        $clone.css({
            transformOrigin: originX + 'px ' + originY + 'px'
        });
        
        // Calculate direction to cart (max 100px)
        const deltaX = cartOffset.left - cardOffset.left;
        const deltaY = cartOffset.top - cardOffset.top;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const maxDistance = 100;
        
        // Calculate target position (limited to 100px)
        const ratio = Math.min(maxDistance / distance, 1);
        const targetLeft = cardOffset.left + (deltaX * ratio);
        const targetTop = cardOffset.top + (deltaY * ratio);
        
        // Animate the entire product card towards cart (max 100px)
        gsap.to($clone[0], {
            duration: 0.8,
            top: targetTop + 'px',
            left: targetLeft + 'px',
            scale: 0.2,
            opacity: 0,
            ease: 'power2.in',
            onComplete: function() {
                $clone.remove();
            }
        });
    }
    
    // Make entire product card clickable for add to cart (except detail button)
    jQuery(document).on('click', '.custom-ajax-cart-form', function(e) {
        // Don't trigger if clicking the detail button or add to cart button
        if (jQuery(e.target).closest('a[href*="product"], .custom-add-to-cart-btn, .btn').length > 0) {
            return;
        }
        
        // Submit the form
        jQuery(this).submit();
    });

    // Default WooCommerce AJAX for single product forms
    jQuery(document).on('submit', 'form.cart:not(.custom-ajax-cart-form)', function(e) {
        e.preventDefault();
        
        const $form = jQuery(this);
        const $button = $form.find('.single_add_to_cart_button');
        
        if ($button.hasClass('processing')) {
            return false;
        }
        
        // Store original text and change to "Adding to cart..."
        const originalText = $button.text();
        $button.addClass('processing').prop('disabled', true).text('Adding to cart...');
        
        const formData = new FormData($form[0]);
        
        jQuery.ajax({
            type: 'POST',
            url: wc_add_to_cart_params.ajax_url,
            data: formData,
            processData: false,
            contentType: false,
            success: function(response) {
                if (response.error && response.product_url) {
                    window.location = response.product_url;
                    return;
                }
                
                // Trigger WooCommerce events
                jQuery(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $button]);
            },
            error: function() {
                // Fallback to default form submission
                $form.off('submit').submit();
            },
            complete: function() {
                $button.removeClass('processing').prop('disabled', false).text(originalText);
            }
        });
        
        return false;
    });

    // Request debouncing to prevent rapid clicks
    let addToCartDebounceTimer = null;
    const pendingAddToCartRequests = new Set();

    // Optimized AJAX Add to Cart - Instant feedback with minimal server processing
    jQuery(document).on('submit', '.custom-ajax-cart-form', function(e) {
        e.preventDefault();
        
        const $form = jQuery(this);
        const $button = $form.find('.custom-add-to-cart-btn');
        const $productCard = $form.find('.product-card');
        const isProductCard = $productCard.length > 0;
        
        // Get product ID from hidden input (move to top)
        const productId = $form.find('input[name="product_id"]').val();
        
        // Check if already processing or if request is pending
        if ($button.hasClass('processing') || pendingAddToCartRequests.has(productId)) {
            return false;
        }
        
        // Add to pending requests to prevent duplicates
        pendingAddToCartRequests.add(productId);
        
        // OPTIMISTIC UI UPDATE - Show success immediately for instant feedback
        $button.prop('disabled', true).addClass('processing');
        setButtonIconState($button, 'success');
        
        // Update cart count optimistically (instant perceived speed)
        const $cartBadge = jQuery('.cart-count-badge');
        let currentCount = parseInt($cartBadge.text()) || 0;
        $cartBadge.text(currentCount + 1).removeClass('hidden');
        
        // Fly to cart animation immediately for better UX
        if (isProductCard) {
            flyToCart($productCard);
        }
        
        // Create minimal FormData for faster AJAX
        const formData = new FormData();
        formData.set('add-to-cart', productId);
        formData.set('quantity', '1');
        formData.append('action', 'woocommerce_ajax_add_to_cart');
        
        // Make AJAX call in background (non-blocking)
        jQuery.ajax({
            type: 'POST',
            url: wc_add_to_cart_params.ajax_url,
            data: formData,
            processData: false,
            contentType: false,
            timeout: 10000, // Reduced timeout since we show optimistic feedback
            cache: false,
            success: function(response) {
                // Remove from pending requests
                pendingAddToCartRequests.delete(productId);
                
                if (response.error) {
                    // Revert optimistic update on error
                    $cartBadge.text(currentCount);
                    if (currentCount === 0) $cartBadge.addClass('hidden');
                    setButtonIconState($button, 'default');
                    $button.prop('disabled', false).removeClass('processing');
                    alert('Error adding to cart. Please try again.');
                    return;
                }
                
                // Update with actual cart count from server
                $cartBadge.text(response.cart_count);
                if (response.cart_count === 0) $cartBadge.addClass('hidden');
                
                // Re-enable button
                $button.prop('disabled', false).removeClass('processing');
                
                // Return to default icon after 2 seconds
                setTimeout(function() {
                    setButtonIconState($button, 'default');
                }, 2000);
                
                // Trigger WooCommerce events with fragments for cart toggle
                jQuery(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $button]);
            },
            error: function(xhr, status, error) {
                // Remove from pending requests
                pendingAddToCartRequests.delete(productId);
                
                // Revert optimistic update on error
                $cartBadge.text(currentCount);
                if (currentCount === 0) $cartBadge.addClass('hidden');
                setButtonIconState($button, 'default');
                $button.prop('disabled', false).removeClass('processing');
                
                // Show user-friendly error message
                if (status === 'timeout') {
                    alert('Request timed out. Please try again.');
                } else {
                    alert('Error adding to cart. Please try again.');
                }
            }
        });
        
        return false;
    });

    // Play button click handler
    document.querySelectorAll('.video-card .play-btn').forEach(btn => {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            const card = btn.closest('.video-card');
            const videoUrl = card.dataset.videoUrl;
            if (!videoUrl) return;

            // Save current body overflow
            const prevOverflow = document.body.style.overflow;
            document.body.style.overflow = 'hidden';

            // Create popup elements
            const popupBg = document.createElement('div');
            popupBg.className = 'video-popup-bg fixed inset-0 bg-black/60 z-[1000] flex items-center justify-center';
            const popup = document.createElement('div');
            popup.className = 'video-popup relative bg-white rounded-2xl shadow-xl overflow-hidden max-w-[90vw] max-h-[85vh] w-[800px] aspect-[2/4] flex items-center justify-center';
            popup.innerHTML = `
                <button class="close-popup absolute top-2 right-2 z-10 bg-white rounded-full w-10 h-10 flex items-center justify-center shadow">
                    <svg width="20" height="20" fill="none" viewBox="0 0 20 20"><path d="M6 6l8 8M14 6l-8 8" stroke="#E04B7B" stroke-width="2" stroke-linecap="round"/></svg>
                </button>
                <iframe src="${videoUrl}" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen class="w-full h-full rounded-2xl"></iframe>
            `;
            popupBg.appendChild(popup);
            document.body.appendChild(popupBg);

            // Animate in
            gsap.fromTo(popupBg, {opacity: 0}, {opacity: 1, duration: 0.3, ease: "power2.out"});
            gsap.fromTo(popup, {scale: 0.8, opacity: 0}, {scale: 1, opacity: 1, duration: 0.3, ease: "power2.out"});

            // Close logic
            function closePopup() {
                gsap.to(popup, {scale: 0.8, opacity: 0, duration: 0.2, ease: "power2.in"});
                gsap.to(popupBg, {
                    opacity: 0, duration: 0.2, ease: "power2.in", onComplete: () => {
                        popupBg.remove();
                        document.body.style.overflow = prevOverflow;
                    }
                });
            }
            popupBg.addEventListener('click', function(e) {
                if (e.target === popupBg) closePopup();
            });
            popup.querySelector('.close-popup').addEventListener('click', closePopup);
        });
    });
});

// Sticky Add to Cart - Mobile Only with IntersectionObserver
document.addEventListener('DOMContentLoaded', () => {
    let originalButton = document.getElementById('original-add-to-cart');
    
    // Fallback: if specific ID not found, look for any add-to-cart form
    if (!originalButton) {
        originalButton = document.querySelector('form.cart');
        if (!originalButton) {
            originalButton = document.querySelector('form.original-add-to-cart-form');
        }
    }
    
    const stickyContainer = document.getElementById('sticky-add-to-cart');
    const stickyBtn = document.querySelector('.sticky-add-btn');
    const footer = document.querySelector('#colophon');
    const relatedProducts = document.querySelector('.related.products') || document.querySelector('[class*="related"]');
    
    if (!originalButton || !stickyContainer) {
        return;
    }
    
    let isFooterVisible = false;
    let isOriginalVisible = true;
    let transitionLock = false;
    
    // Click handler for sticky button - trigger original form
    stickyBtn?.addEventListener('click', () => {
        originalButton.querySelector('button[type="submit"]')?.click();
    });
    
    // Function to update sticky button position
    function updateStickyPosition() {
        if (window.innerWidth >= 1024) return;
        
        // Kill any existing GSAP animations first
        gsap.killTweensOf(stickyContainer);
        
        if (isFooterVisible) {
            // Footer is visible - change to relative positioning
            // First, fade out if needed
            gsap.to(stickyContainer, {
                opacity: 0,
                duration: 0.15,
                ease: 'power2.in',
                onComplete: () => {
                    // Change positioning after fade out
                    requestAnimationFrame(() => {
                        stickyContainer.style.position = 'relative';
                        stickyContainer.style.bottom = 'auto';
                        stickyContainer.style.left = 'auto';
                        stickyContainer.style.right = 'auto';
                        stickyContainer.style.transform = '';
                        
                        // Insert after related products section if it exists
                        if (relatedProducts && !relatedProducts.nextElementSibling?.contains(stickyContainer)) {
                            relatedProducts.parentNode.insertBefore(stickyContainer, relatedProducts.nextSibling);
                        }
                        
                        // Fade back in if original button not visible
                        if (!isOriginalVisible) {
                            gsap.to(stickyContainer, {
                                opacity: 1,
                                duration: 0.15,
                                ease: 'power2.out'
                            });
                        }
                    });
                }
            });
        } else {
            // Footer not visible - return to fixed positioning
            // First, fade out
            gsap.to(stickyContainer, {
                opacity: 0,
                duration: 0.15,
                ease: 'power2.in',
                onComplete: () => {
                    // Change positioning after fade out
                    requestAnimationFrame(() => {
                        stickyContainer.style.position = '';
                        stickyContainer.style.bottom = '';
                        stickyContainer.style.left = '';
                        stickyContainer.style.right = '';
                        stickyContainer.style.transform = '';
                        
                        // Move back to original location in DOM
                        const originalParent = document.querySelector('.woocommerce-product-details__short-description')?.parentElement 
                            || document.querySelector('.summary.entry-summary');
                        
                        if (originalParent && !originalParent.contains(stickyContainer)) {
                            originalParent.appendChild(stickyContainer);
                        }
                    });
                }
            });
        }
    }
    
    // Footer observer with debouncing
    if (footer) {
        const footerObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (transitionLock) return;
                    
                    const newFooterState = entry.isIntersecting;
                    if (newFooterState !== isFooterVisible) {
                        isFooterVisible = newFooterState;
                        transitionLock = true;
                        updateStickyPosition();
                        setTimeout(() => {
                            transitionLock = false;
                        }, 400); // Slightly longer than animation duration
                    }
                });
            },
            {
                threshold: 0,
                rootMargin: '50px 0px 50px 0px' // Larger margin to reduce trigger frequency
            }
        );
        
        footerObserver.observe(footer);
    }
    
    // IntersectionObserver for better performance
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach(entry => {
                const newOriginalState = entry.isIntersecting;
                
                // Only update if state actually changed
                if (newOriginalState === isOriginalVisible) return;
                
                isOriginalVisible = newOriginalState;
                
                // Kill existing animations
                gsap.killTweensOf(stickyContainer);
                
                if (entry.isIntersecting) {
                    // Original button visible - hide sticky
                    gsap.to(stickyContainer, {
                        y: '100%',
                        opacity: 0,
                        duration: 0.3,
                        ease: 'power2.in'
                    });
                } else {
                    // Original button not visible
                    if (!isFooterVisible) {
                        // Fixed position at bottom - reset transform first
                        stickyContainer.style.transform = '';
                        gsap.to(stickyContainer, {
                            y: 0,
                            opacity: 1,
                            duration: 0.3,
                            ease: 'power2.out'
                        });
                    } else {
                        // Relative position - handled by updateStickyPosition
                        updateStickyPosition();
                    }
                }
            });
        },
        {
            threshold: 0,
            rootMargin: '0px 0px -100px 0px' // Trigger slightly before fully out of view
        }
    );
    
    observer.observe(originalButton);
    
    // Handle resize to disable on desktop
    window.addEventListener('resize', () => {
        if (window.innerWidth >= 1024) {
            // Disable on desktop
            gsap.set(stickyContainer, { y: '100%', opacity: 0 });
            observer.disconnect();
        } else {
            updateStickyPosition();
        }
    });
});
